import React from 'react';
import { RoleProtectedRoute } from '../../../../components/RoleProtectedRoute';
import { BrandLoader } from '../../../../components/ui/BrandLoader';
import { useDemoPreviews } from './useDemoPreviews';

/** Module-level so the reference is stable (same idea as NO_ROLES in App.tsx). */
const NO_ROLES: string[] = [];

/**
 * Route gate for UI-only demo preview pages. Three states, mirroring RoleProtectedRoute:
 *   - loading  → inline loader, no decision yet;
 *   - disabled → the app's established "feature is off" behaviour (CO-239): RoleProtectedRoute with an empty
 *                role set shows the brief no-access notice, then redirects home. The SPA has no path="*", so
 *                this is the closest thing to "unknown route" that does not render blank chrome.
 *   - enabled  → children.
 * Compose INSIDE the role gate in App.tsx: <RoleProtectedRoute allowedRoles={HR_ONLY_ROLES}><PreviewRoute>…
 */
export function PreviewRoute({ children }: { children: React.ReactElement }) {
  const { enabled, loading } = useDemoPreviews();
  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <BrandLoader variant="inline" size="md" />
      </div>
    );
  }
  if (!enabled) {
    return (
      <RoleProtectedRoute allowedRoles={NO_ROLES}>
        <></>
      </RoleProtectedRoute>
    );
  }
  return children;
}

export default PreviewRoute;
